var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import SelectFilter from '@/components/select-filter/SelectFilter';
import AsyncSelect from '@/components/async-select/AsyncSelect';
import LoaderCard from '@/components/loader-card/LoaderCard';
import DataTable from '@/components/data-table/DataTable';
import { Teacher } from '@/models/Teacher';
import { Subject } from '@/models/Subject';
import { colorHtml, avatarHtml } from '@/support/String';
import { Room } from '@/models/Room';
import { Level } from '@/models/Level';
import { Group } from '@/models/Group';
import { UserSubject } from '@/models/UserSubject';
import ErrorHandler from '@/support/ErrorHandler';
import { Activity } from '@/models/Activity';
import { Timeslot } from '@/models/Timeslot';
import { reverseDayMap } from '@/support/CalendarDefaults';
import { formatDate as format } from '@/support/String';
import { DateTime } from 'luxon';
import { sortByKey } from '@/support/Object';
import { whiteAreaIcons, whiteKidIcons } from '@/support/Icon';
import Storage from '@/support/Storage';
let CreateActivityDialog = class CreateActivityDialog extends Vue {
    constructor() {
        super(...arguments);
        this.activity = null;
        this.visibility = { checkboxes: false };
        this.selectedTeachers = [];
        this.selectedAreas = [];
        this.selectedTopics = [];
        this.selectedTeacherAreas = [];
        this.selectedRoom = [];
        this.selectedLevels = [];
        this.selectedGroups = [];
        this.teacherSubjects = [];
        this.userSubjects = [];
        this.isMandatoryLevels = false;
        this.isMandatoryGroups = false;
        this.isDoublePeriod = false;
        this.isLoading = true;
        this.isFilled = false;
        this.clearSelects = false;
        this.currentStep = 1;
        this.selectedDoublePeriodTimeslot = null;
        this.selectedTeacherAreaId = [];
    }
    mounted() {
        this.initialize();
    }
    initialize() {
        this.isLoading = true;
        if (!this.activityId) {
            this.isFilled = true;
            this.isLoading = false;
            return;
        }
        new Activity()
            .include(['groups', 'levels', 'meta', 'room', 'areas', 'topics', 'teacher', 'users', 'timeslots'])
            .find(this.activityId)
            .then((activity) => {
            this.activity = activity;
            this.fillSelected();
            const totalTimeslots = this.activity && this.activity.timeslots ? this.activity.timeslots.length : 0;
            if (totalTimeslots > 1) {
                this.isDoublePeriod = true;
                this.selectedDoublePeriodTimeslot = this.activity.timeslots[totalTimeslots - 1].id;
            }
            this.isLoading = false;
            this.currentStep = 6;
        });
    }
    fetchUserSubject() {
        this.teacherSubjects = [];
        if (this.selectedTeachers.length === 0) {
            this.isFilled = true;
            return;
        }
        this.selectedTeachers.forEach((selected) => {
            new UserSubject()
                .user(selected.id || '')
                .all()
                .then((teacherSubjects) => {
                const activityAreaId = this.activity && this.activity.areas && this.activity.areas.length ? this.activity.areas[0].id : '';
                const matchingTeacherSubjects = teacherSubjects.filter((subject) => {
                    return subject.subject === activityAreaId;
                });
                this.parseToTeacherSubject(teacherSubjects);
                if (this.selectedSubjectAreaId !== activityAreaId) {
                    this.selectedTopics = [];
                    this.isFilled = true;
                    return;
                }
                if (this.activity && matchingTeacherSubjects) {
                    this.setSelectedTeacherAreas(matchingTeacherSubjects);
                }
                this.$nextTick(() => {
                    this.isFilled = true;
                });
            })
                .catch((error) => {
                ErrorHandler.network(error);
            });
        });
    }
    deleteArea(subject) {
        if (subject && subject.id) {
            const index = this.findAreaId(subject.id);
            this.selectedAreas.splice(index, 1);
            this.selectedTopics = [];
        }
    }
    deleteTopic(topic) {
        if (topic && topic.id) {
            const index = this.findTopicId(topic.id);
            this.selectedTopics.splice(index, 1);
        }
    }
    deleteTeacherArea(userSubject) {
        if (userSubject && userSubject.id) {
            const index = this.selectedTeacherAreas.findIndex((currentSubject) => {
                // TODO: fix any
                return currentSubject.userSubject.id === userSubject.id;
            });
            if (index >= 0) {
                this.selectedTeacherAreas.splice(index, 1);
                this.selectedTopics = [];
            }
        }
    }
    deleteLevel(level) {
        if (level && level.id) {
            const index = this.findLevelId(level.id);
            this.selectedLevels.splice(index, 1);
        }
    }
    deleteGroup(group) {
        if (group && group.id) {
            const index = this.findGroupId(group.id);
            this.selectedGroups.splice(index, 1);
        }
    }
    setSelectedTeacherAreas(subjects) {
        const areas = this.$store.state.curriculum.subjects;
        subjects.forEach((userSubject) => {
            const area = areas.find((subject) => {
                return subject.id === userSubject.subject;
            });
            const teacherSubjects = [];
            const teacherSubject = {
                id: userSubject.id,
                name: userSubject.name,
                color: area.color || '',
                userSubject,
                isEditing: false,
                icon: userSubject.icon,
            };
            teacherSubjects.push(teacherSubject);
            this.selectedAreas = [];
            this.selectedTeacherAreaId = teacherSubjects.map((teacherSubject) => {
                this.isFilled = true;
                return teacherSubject.id || '';
            });
        });
    }
    parseToTeacherSubject(subjects) {
        const areas = this.$store.state.curriculum.subjects;
        subjects.forEach((userSubject) => {
            const area = areas.find((subject) => {
                return subject.id === userSubject.subject;
            });
            const teacherSubject = {
                id: userSubject.id,
                name: userSubject.name,
                color: area.color || '',
                userSubject,
                isEditing: false,
                icon: userSubject.icon,
            };
            this.teacherSubjects.push(teacherSubject);
        });
    }
    setTeacherSubject() {
        if (this.selectedTeacherAreaId && this.selectedTeacherAreaId.length) {
            if (this.selectedTeacherAreaId.length > 1) {
                const index = this.findTeacherAreaId(this.selectedTeacherAreaId[0]);
                this.selectedTeacherAreaId.splice(index, 1);
            }
            if (this.selectedAreas.length) {
                const index = this.findAreaId(this.selectedAreas[0].id);
                this.selectedAreas.splice(index, 1);
            }
            const match = this.teacherSubjects.find((subject) => {
                return subject.id === this.selectedTeacherAreaId[0];
            });
            if (match && this.selectedTeacherAreas.length > 0) {
                const index = this.findTeacherAreaId(this.selectedTeacherAreas[0]);
                this.selectedTeacherAreas.splice(index, 1);
            }
            this.selectedTeacherAreas.push(match);
        }
    }
    emptySelectedValues() {
        if (this.selectedAreas && this.selectedAreas.length) {
            this.selectedTeacherAreaId = [];
            this.selectedTeacherAreas = [];
            this.selectedTopics = [];
            this.selectedRoom = [];
            this.selectedLevels = [];
            this.selectedGroups = [];
            this.roomDataTable ? this.roomDataTable.refresh() : null;
            this.levelsDataTable ? this.levelsDataTable.refresh() : null;
            this.groupsDataTable ? this.groupsDataTable.refresh() : null;
        }
    }
    createOrUpdate() {
        this.isLoading = true;
        if (this.activity) {
            this.update();
        }
        else {
            this.create();
        }
    }
    update() {
        const payload = this.createPayload();
        if (this.activity) {
            this.activity.put(payload).then(() => {
                this.isLoading = false;
                this.currentStep = 7;
                this.$emit('activityUpdated');
            });
        }
    }
    createPayload() {
        const areas = [
            ...new Set([
                ...this.selectedTeacherAreas.map((subject) => {
                    if (subject.userSubject) {
                        return subject.userSubject.subject;
                    }
                }),
                ...this.selectedAreas.map((subject) => {
                    return subject.id;
                }),
            ]),
        ];
        const payload = {
            timeslots: this.selectedTimeslots,
            type: 'lesson',
            users: this.selectedTeachers.map((teacher) => {
                return teacher.id;
            }),
            room: this.parseSelectedRoom(this.selectedRoom),
            areas,
            topics: this.selectedTopics.map((topic) => {
                return topic.id;
            }),
            levels: this.selectedLevels.map((level) => {
                return {
                    id: level.id,
                    is_mandatory: this.isMandatoryLevels,
                };
            }),
            groups: this.selectedGroups.map((group) => {
                return {
                    id: group.id,
                    is_mandatory: this.isMandatoryGroups,
                };
            }),
            prevent_creating_block: this.isDoublePeriod && this.selectedDoublePeriodTimeslot ? false : true,
        };
        return payload;
    }
    parseSelectedRoom(room) {
        if (Array.isArray(room) && room.length > 0) {
            return room[0].id;
        }
        return '';
    }
    fillSelected() {
        if (!this.activity) {
            return;
        }
        const rooms = [this.activity.room];
        this.$set(this, 'selectedGroups', this.activity.groups);
        this.selectedGroups.map((group) => {
            if (group.is_mandatory) {
                this.isMandatoryGroups = true;
            }
        });
        this.$set(this, 'selectedLevels', this.activity.levels);
        this.selectedLevels.map((level) => {
            if (level.is_mandatory) {
                this.isMandatoryLevels = true;
            }
        });
        this.$set(this, 'selectedRoom', rooms);
        this.$set(this, 'selectedAreas', this.activity.areas);
        this.$set(this, 'selectedTopics', this.activity.topics);
        this.$set(this, 'selectedTeachers', this.activity.users);
        this.isFilled = true;
    }
    refreshDataTable() {
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
    findAreaId(id) {
        return this.selectedAreas.findIndex((subject) => subject.id === id);
    }
    findTeacherAreaId(id) {
        return this.selectedTeacherAreaId.findIndex((id) => id === id);
    }
    findTopicId(id) {
        return this.selectedTopics.findIndex((topic) => topic.id === id);
    }
    findLevelId(id) {
        return this.selectedLevels.findIndex((level) => level.id === id);
    }
    findGroupId(id) {
        return this.selectedGroups.findIndex((group) => group.id === id);
    }
    create() {
        const payload = this.createPayload();
        new Activity()
            .create(payload)
            .then((activity) => {
            this.isLoading = false;
            this.currentStep = 7;
            this.$emit('activityCreated');
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    close() {
        this.$emit('input', false);
        this.clearSelects = false;
        this.isFilled = false;
        this.currentStep = 1;
    }
    clear() {
        this.clearSelects = true;
        this.selectedTeachers = [];
        this.selectedAreas = [];
        this.selectedTopics = [];
        this.selectedRoom = [];
        this.selectedLevels = [];
        this.selectedGroups = [];
        this.teacherSubjects = [];
        this.userSubjects = [];
        this.isMandatoryLevels = false;
        this.isMandatoryGroups = false;
        this.$nextTick(() => {
            this.close();
        });
    }
    findTimeslotById(timeslotId) {
        const timeslot = this.timeslots.find((timeslot) => {
            return timeslot.id === timeslotId;
        });
        return timeslot || null;
    }
    get formattedTimeSlotDay() {
        if (!this.timeslot) {
            return;
        }
        const weekDay = this.weekDays.find((weekDay) => {
            return weekDay.key == this.timeslot.day;
        });
        return weekDay ? weekDay.title.charAt(0).toUpperCase() + weekDay.title.slice(1) : '-';
    }
    get weekDays() {
        return [
            {
                key: '1',
                title: this.$t('weekDays.monday').toString(),
            },
            {
                key: '2',
                title: this.$t('weekDays.tuesday').toString(),
            },
            {
                key: '3',
                title: this.$t('weekDays.wednesday').toString(),
            },
            {
                key: '4',
                title: this.$t('weekDays.thursday').toString(),
            },
            {
                key: '5',
                title: this.$t('weekDays.friday').toString(),
            },
            {
                key: '6',
                title: this.$t('weekDays.saturday').toString(),
            },
            {
                key: '7',
                title: this.$t('weekDays.sunday').toString(),
            },
        ];
    }
    get tableOptionsTeachers() {
        return {
            name: {
                singular: this.$tc('group.teacher', 1),
                plural: this.$tc('group.teacher', 2),
            },
            headers: [
                {
                    text: '',
                    value: 'avatar',
                    transform: avatarHtml,
                },
                {
                    text: this.$t('name.title').toString(),
                    value: 'name',
                },
            ],
            actions: [],
            filters: [],
            model: new Teacher().filter(this.filters),
        };
    }
    get tableOptionsAllAreas() {
        return {
            name: {
                singular: this.$tc('subject.area.title', 1),
                plural: this.$tc('subject.area.title', 2),
            },
            headers: [
                {
                    text: '',
                    value: 'color',
                    transform: colorHtml,
                },
                {
                    text: this.$t('name.title').toString(),
                    value: 'name',
                },
            ],
            actions: [],
            filters: [],
            dropdown: [],
            model: new Subject().filter('depth', 0),
        };
    }
    get tableOptionsAllTopics() {
        return {
            name: {
                singular: this.$tc('subject.topic.title', 1),
                plural: this.$tc('subject.topic.title', 2),
            },
            headers: [
                {
                    text: '',
                    value: 'color',
                    transform: colorHtml,
                },
                {
                    text: this.$t('name.title').toString(),
                    value: 'name',
                },
            ],
            actions: [],
            filters: [],
            dropdown: [],
            model: new Subject().filter({
                depth: 1,
                parent: this.selectedAreas && this.selectedAreas.length ? this.selectedSubjectAreaId : this.selectedTeacherSubjectAreaId,
            }),
        };
    }
    get selectedSubjectAreaId() {
        if (this.selectedAreas) {
            const areas = this.selectedAreas.map((subject) => {
                return subject.id;
            });
            return areas && areas[0] ? areas[0] : '';
        }
    }
    get selectedTeacherSubjectAreaId() {
        if (this.selectedTeacherAreas) {
            const topics = this.selectedTeacherAreas.map((subject) => {
                // TODO: fix any
                return subject.userSubject.subject;
            });
            return topics && topics[0] ? topics[0] : '';
        }
    }
    get tableOptionsRooms() {
        return {
            name: {
                singular: this.$tc('room.title', 1),
                plural: this.$tc('room.title', 2),
            },
            headers: [
                {
                    text: '',
                    value: 'color',
                    transform: colorHtml,
                },
                {
                    text: this.$t('name.title').toString(),
                    value: 'name',
                },
            ],
            actions: [],
            filters: [],
            dropdown: [],
            model: new Room().filter(this.filters),
        };
    }
    get tableOptionsLevels() {
        return {
            name: {
                singular: this.$tc('level.title', 1),
                plural: this.$tc('level.title', 2),
            },
            headers: [
                {
                    text: this.$t('name.title').toString(),
                    value: 'name',
                },
            ],
            actions: [],
            filters: [],
            dropdown: [],
            model: new Level(),
        };
    }
    get tableOptionsGroups() {
        return {
            name: {
                singular: this.$tc('group.title', 1),
                plural: this.$tc('group.title', 2),
            },
            headers: [
                {
                    text: this.$t('name.title').toString(),
                    value: 'name',
                },
            ],
            actions: [],
            filters: [],
            dropdown: [],
            model: new Group(),
        };
    }
    get filteredTimeslots() {
        if (!this.timeslot) {
            return [];
        }
        const startTimeslot = this.activity && this.activity.timeslots && this.activity.timeslots[0] ? this.activity.timeslots[0] : this.timeslot;
        let filteredTimeslots = [];
        this.timeslots.forEach((slot) => {
            if (slot.day === this.timeslot.day) {
                filteredTimeslots.push(slot);
            }
        });
        filteredTimeslots = filteredTimeslots.filter((slot) => {
            if (slot.id === this.selectedDoublePeriodTimeslot && startTimeslot.id !== slot.id) {
                return true;
            }
            if (slot.starts_at && startTimeslot.ends_at) {
                const startTime = Date.parse(`1970-01-01T${slot.starts_at}`);
                const endTime = Date.parse(`1970-01-01T${DateTime.fromSQL(startTimeslot.ends_at).toFormat('HH:mm:ss')}`);
                return startTime >= endTime;
            }
        });
        return filteredTimeslots;
    }
    get filters() {
        const filter = {};
        if (this.timeslot && this.timeslot.id) {
            filter.is_available_for_timeslot = this.timeslot.id;
        }
        if (this.timeslot && Array.isArray(this.timeslot)) {
            filter.is_available_for_timeslots = this.timeslot.map((t) => t.id);
        }
        if (this.activity && this.activity.id) {
            filter.is_available_for_activity = this.activity.id;
        }
        return filter;
    }
    get mergedSelectedAreas() {
        const subjects = [];
        if (this.selectedTeacherAreas) {
            this.selectedTeacherAreas.forEach((teacherSubject) => {
                subjects.push({
                    id: teacherSubject.userSubject.subject,
                    name: teacherSubject.userSubject.name,
                    type: 'teacher',
                    original: teacherSubject.userSubject,
                });
            });
        }
        if (this.selectedAreas) {
            this.selectedAreas.forEach((normalSubject) => {
                subjects.push({
                    id: normalSubject.id,
                    name: normalSubject.name,
                    type: 'normal',
                    original: normalSubject,
                });
            });
        }
        const uniqueSubjects = [];
        subjects.forEach((subject) => {
            if (uniqueSubjects.find((newSubject) => {
                return newSubject.id === subject.id;
            })) {
                return;
            }
            uniqueSubjects.push(subject);
        });
        return uniqueSubjects;
    }
    get selectedTimeslots() {
        if (Array.isArray(this.timeslot)) {
            return this.timeslot.map((timeslot) => timeslot.id);
        }
        const timeslots = [];
        let timeslotFound = false;
        if (!this.isDoublePeriod && this.timeslot.id) {
            return [this.timeslot.id];
        }
        if (!this.selectedDoublePeriodTimeslot && this.timeslot.id) {
            return [this.timeslot.id];
        }
        const possibleTimeslots = this.timeslots.sort(sortByKey('starts_at'));
        possibleTimeslots.forEach((timeslot) => {
            if (timeslotFound || !timeslot.id) {
                return;
            }
            const firstTimeslotStartsAt = DateTime.fromSQL(this.firstTimeslot.starts_at).toFormat('HH:mm:ss');
            if (timeslot.starts_at < firstTimeslotStartsAt) {
                return;
            }
            timeslots.push(timeslot.id);
            if (timeslot.id === this.selectedDoublePeriodTimeslot) {
                timeslotFound = true;
            }
        });
        return timeslots;
    }
    get firstTimeslot() {
        if (this.activity && this.activity.timeslots && this.activity.timeslots.length > 0) {
            const timeslots = this.activity.timeslots.sort(sortByKey('starts_at'));
            return timeslots[0];
        }
        if (this.timeslot) {
            return this.timeslot;
        }
        return this.findTimeslotById(this.selectedTimeslots[0]);
    }
    get lastTimeslot() {
        const lastTimeslotIndex = this.selectedTimeslots.length - 1;
        return this.findTimeslotById(this.selectedTimeslots[lastTimeslotIndex]);
    }
    get roomDataTable() {
        const dataTable = this.$refs.roomDataTable;
        if (dataTable) {
            return dataTable;
        }
        return null;
    }
    get levelsDataTable() {
        const dataTable = this.$refs.levelsDataTable;
        if (dataTable) {
            return dataTable;
        }
        return null;
    }
    get groupsDataTable() {
        const dataTable = this.$refs.groupsDataTable;
        if (dataTable) {
            return dataTable;
        }
        return null;
    }
    get whiteIcons() {
        const type = Storage.get('type');
        return type && type.toLowerCase() === 'po' ? whiteAreaIcons : whiteKidIcons;
    }
    activityChanged(activity) {
        if (activity) {
            this.$nextTick(() => {
                this.fillSelected();
            });
        }
    }
    subjectSelected() {
        this.emptySelectedValues();
    }
    changedTeacherAreaId() {
        this.setTeacherSubject();
    }
    currentStepChanged() {
        if (this.currentStep === 2 && !(this.selectedAreas && this.selectedAreas.length)) {
            this.isFilled = false;
            this.fetchUserSubject();
        }
    }
};
__decorate([
    Prop({ default: null }),
    __metadata("design:type", typeof (_a = typeof Timeslot !== "undefined" && Timeslot) === "function" ? _a : Object)
], CreateActivityDialog.prototype, "timeslot", void 0);
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], CreateActivityDialog.prototype, "timeslots", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], CreateActivityDialog.prototype, "isMultiple", void 0);
__decorate([
    Prop({ default: null }),
    __metadata("design:type", String)
], CreateActivityDialog.prototype, "activityId", void 0);
__decorate([
    Watch('activity'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_b = typeof Activity !== "undefined" && Activity) === "function" ? _b : Object]),
    __metadata("design:returntype", void 0)
], CreateActivityDialog.prototype, "activityChanged", null);
__decorate([
    Watch('selectedAreas'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CreateActivityDialog.prototype, "subjectSelected", null);
__decorate([
    Watch('selectedTeacherAreaId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CreateActivityDialog.prototype, "changedTeacherAreaId", null);
__decorate([
    Watch('currentStep'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CreateActivityDialog.prototype, "currentStepChanged", null);
CreateActivityDialog = __decorate([
    Component({
        components: {
            AsyncSelect,
            SelectFilter,
            LoaderCard,
            DataTable,
        },
        filters: {
            formatDay(day) {
                const formatted = reverseDayMap[day];
                return `${formatted.charAt(0).toUpperCase()}${formatted.slice(1)}`;
            },
            formatTime(time) {
                return !time ? '' : format(time, 'HH:mm');
            },
        },
    })
], CreateActivityDialog);
export default CreateActivityDialog;
